import { ModalTypeUpgradePlan } from '../types'
import { HomeActionTypes } from './actions'
import type { HomeAction, HomeState } from './types'

export const initialState: HomeState = {
  upgradeModal: {
    isShow: false,
    type: ModalTypeUpgradePlan.STARTER
  }
}

const homeReducer = (state: HomeState, action: HomeAction): HomeState => {
  switch (action.type) {
    case HomeActionTypes.TOGGLE_UPGRADE_MODAL:
      return {
        ...state,
        upgradeModal: {
          isShow: action.payload.isShow,
          type: action.payload.type
        }
      }
    default:
      return state
  }
}

export default homeReducer
